import Axios, { AxiosError } from 'axios';
import eventEmitter from '../utils/eventEmitter';
import { authApi } from './authApi';

/**
 * Define a baseURL para o Acta
 */
function mountBaseUrlActa() {
  const env = process.env.NODE_ENV;
  if (env === 'development') {
    return 'http://localhost:8002/api';
  }
  return 'https://acta.publisol.com.br/api';
}

// Cria a instância do Axios para ACTA
const actaApi = Axios.create({
  baseURL: mountBaseUrlActa(),
  withCredentials: true,
});

actaApi.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config;

    // Tenta o refresh token se receber 401
    if (error.response?.status === 401 && originalRequest) {
      if (!(originalRequest as any)._retry) {
        (originalRequest as any)._retry = true;
        try {
          await authApi.post('/token/refresh/');
          return actaApi(originalRequest);
        } catch (refreshError) {
          // Se falhar o refresh, emite logout
          eventEmitter.emit('logout');
          return Promise.reject(refreshError);
        }
      } else {
        // Já tentou o refresh antes e falhou
        eventEmitter.emit('logout');
      }
    }

    return Promise.reject(error);
  },
);

export { actaApi };
